import { useLaunchDarklyFlag } from '@/hooks/flags/useLaunchDarklyFlag';
import { isCategoryFirstEnabledFor } from '@/utils/booking/categoryTrackingProps';

/** Umbrella LaunchDarkly flag for the whole salon alpha booking experience. */
export const SALONS_ALPHA_BOOKING_FLAG = 'salons-alpha-booking';

type CategoryFirstShop = {
  brand?: { settings?: { categoryFirstBookingEnabled?: boolean } };
};

/**
 * Category-first booking applies only when the `salons-alpha-booking` flag is on AND the
 * brand opted in via `settings.categoryFirstBookingEnabled`.
 */
export function useIsCategoryFirstEnabled(shop: CategoryFirstShop): boolean {
  const isFlagEnabled = useLaunchDarklyFlag(SALONS_ALPHA_BOOKING_FLAG, false);

  return isCategoryFirstEnabledFor(isFlagEnabled, shop);
}
